import { useState } from "react";
import { useParams } from "react-router";

import { CardDefinitionEditForm } from "src/app/features/CardImplementation/subFeatures/CardDefinition/components/forms/CardDefinitionEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";

export const CardDefinitionEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const { cardImplementationId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.CARD_IMPLEMENTATIONS}/${FORM_ACTION.EDIT}/${cardImplementationId}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardDefinitionsEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardDefinitionEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
